import React from "react";
import { useInView } from "react-intersection-observer";
import "../styles/Contacthero.css";
import teamImg from "../assets/applynow.jpeg";
import parallaxImg from "../assets/mdmessage.webp";

const Contacthero = () => {
  const [box1Ref, box1InView] = useInView({ triggerOnce: true, threshold: 0.5 });
  const [box2Ref, box2InView] = useInView({ triggerOnce: true, threshold: 0.5 });
  const [detailRef, detailInView] = useInView({ triggerOnce: true, threshold: 0.4 });
  const [mapRef, mapInView] = useInView({ triggerOnce: true, threshold: 0.4 });

  return (
    <div className="contacthero-container">
      <div className="contacthero-header">
        <h1>Careers</h1>
      </div>

      <div className="contacthero-boxes">
        <div
          ref={box1Ref}
          className={`contacthero-box ${box1InView ? "animate-fadeUp" : ""}`}
        >
          <h2>Join Our Team</h2>
          <p>
            Be a part of a forward-thinking company that values innovation,
            dedication, and personal growth.
          </p>
          <div className="contacthero-layer">
            <span>Open positions available worldwide</span>
          </div>
        </div>

        <div
          ref={box2Ref}
          className={`contacthero-box ${box2InView ? "animate-fadeUp" : ""}`}
        >
          <h2>Why Work With Us</h2>
          <p>
            We offer a dynamic workplace, opportunities to grow, and an inclusive
            culture where everyone matters.
          </p>
          <div className="contacthero-layer">
            <span>Flexible hours and remote options</span>
          </div>
        </div>
      </div>

      <div
        ref={detailRef}
        className={`contacthero-detail ${detailInView ? "animate-fadeUp" : ""}`}
      >
        <div className="contacthero-text">
          <h2>Build Your Future With Us</h2>
          <p>
            Our culture is built on trust, innovation, and respect. Whether you're
            just starting out or looking to take your career to the next level, we
            provide the tools and opportunities to grow.
          </p>
        </div>
        <div className="contacthero-image">
          <img src={teamImg} alt="Our Team" />
        </div>
      </div>

      <div
        className="contacthero-parallax-section"
        style={{ backgroundImage: `url(${parallaxImg})` }}
      />

      <div
        ref={mapRef}
        className={`contacthero-map-wrapper ${mapInView ? "animate-fadeUp" : ""}`}
      >
        <div className="contacthero-address-box">
          <h3>Chennai Office</h3>
          <p>
            Matrix Consultancy Services<br />
            1/53,1st Floor ,2nd Street,<br />
            Sripuram Colony, St.Thomas Mount,Chennai,<br />
            Tamil Nadu- 600 016.<br />
            Email: <a href="mailto:hr@matrixconsultancy.in">hr@matrixconsultancy.in</a><br />
            Mobile: +91 8925288802
          </p>
        </div>

        <div className="contacthero-map-box">
          <iframe src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3887.427531969488!2d80.19865057507708!3d13.008424187310323!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTPCsDAwJzMwLjMiTiA4MMKwMTInMDQuNCJF!5e0!3m2!1sen!2sin!4v1755492152341!5m2!1sen!2sin" width="100%" height="100%"  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        </div>
      </div>
    </div>
  );
};

export default Contacthero;
